import * as Actions from '../../actions';

const initialState = { data: null };

const listDropoffSampleReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_DROPOFF_SAMPLE_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listDropoffSampleReducer;
